import React from "react";
import { AppBar, Toolbar, Typography, Button, Box, useTheme, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";

export default function Navbar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isLargeUp = useMediaQuery(theme.breakpoints.up('lg')); // lg ke atas

  return (
    <AppBar position="static" color="primary">
      <Toolbar
        sx={{
          position: 'relative',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: isMobile ? 1 : 0,
          px: 2,
        }}
      >
        {/* Judul di kiri kalau lg ke atas, tengah kalau mobile */}
        <Typography
          variant="h6"
          component="div"
          sx={{
            order: isMobile ? 1 : 0,
            flexGrow: isLargeUp ? 0 : 1,
            textAlign: isLargeUp ? 'left' : 'center',
            width: isLargeUp ? 'auto' : '100%',
          }}
        >
          My Portfolio
        </Typography>

        {/* Menu navigasi */}
        <Box
          sx={{
            order: isMobile ? 2 : 1,
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: 2,
            width: isMobile ? "100%" : "auto",
            justifyContent: isMobile ? "center" : isLargeUp ? "center" : "flex-end",
            flexGrow: isMobile ? 0 : 1,
          }}
        >
          <Button fullWidth={isMobile} color="inherit" component={Link} to="/">
            Home
          </Button>
          <Button fullWidth={isMobile} color="inherit" component={Link} to="/about">
            About
          </Button>
          <Button fullWidth={isMobile} color="inherit" component={Link} to="/projects">
            Projects
          </Button>
          <Button fullWidth={isMobile} color="inherit" component={Link} to="/contact">
            Contact
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
